const isIE = () => {
  const ua = window.navigator.userAgent;
  const oldIE = ua.indexOf('MSIE ');
  const newIE = ua.indexOf('Trident/');
  return (oldIE > -1) || (newIE > -1);
};

export default isIE;
